var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { onModalOpenClose } from "src/redux/reducers/modals";
import { calculateAveragePriceAsPerFilter, convertNumberToShortText, getOrderBookCaching, } from "src/utils/methods";
import { getDataFromSession, SESSION_KEYS } from "src/utils/session-storage";
import styles from "./footer.module.scss";
import { heartBeatData, subscribeToData } from "../../utils/websocketwrapper";
import moment from "moment";
import { getOrderUpdates } from "src/apis/dashboard";
import { isEmpty, isNumber } from "lodash";
import { setBookedPLValue, setPositionDetail, setPositionRefreshTriggered, setTotalPLValue, setUnbookedPLValue, } from "src/redux/reducers/pl-refresh-update";
import { refreshNetPosition } from "src/redux/reducers/common-reducer";
import { setChangeOnOrder } from "src/redux/reducers/order-updates";
import { marginUpdate } from "src/redux/reducers/non-persist";
const FooterPNL = ({ onTabChange, handlePositionClick, }) => {
    const refreshTime = 5000;
    const componentName = "FooterIndex";
    const callNetPosition = useAppSelector((state) => state.commonReducer.callNetPosition);
    const positionUpdateSocketTrigger = useAppSelector((state) => state.plUpdate.positionUpdateSocketTrigger);
    const orderUpdateSocketTrigger = useAppSelector((state) => state.orderUpdate.orderUpdateSocketTrigger);
    const isPollingEnable = useAppSelector((state) => state.commonReducer.isPollingEnable);
    const pollingUpdateFireBase = useAppSelector((state) => state.commonReducer.pollingUpdateFireBase);
    const [totalPL, setTotalPL] = useState(0);
    const isWindowFocused = useAppSelector((state) => state.app.isWindowFocused);
    const interval = useRef();
    const [positionData, setPositionData] = useState([]);
    const lastOrderUpdateTime = useRef(moment().format("YYYY-MM-DD HH:mm:ss"));
    const openFeedWsHeartBeat = useAppSelector((state) => state.openFeedWs.heartBeat);
    const dispatch = useAppDispatch();
    //   const totalPL = useAppSelector((state) => {
    //     return state.plUpdate.totalPL;
    //   });
    const positionRefreshTriggered = useAppSelector((state) => state.plUpdate.posRefreshTriggered);
    //-------------------------------Websocket---------------------------------------------------------
    const sendWsMessage = (heartBeatMessage, localPositionData) => {
        if (localPositionData.length == 0) {
            return;
        }
        const outputArray = localPositionData.map((singleOrder) => {
            return {
                Exch: singleOrder.Exch,
                ExchType: singleOrder.ExchType,
                ScripCode: singleOrder.ScripCode,
            };
        });
        const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
        const method1 = {
            Method: "MarketFeedV3",
            Operation: "Subscribe",
            ClientCode: clientCode,
            MarketFeedData: outputArray,
        };
        if (heartBeatMessage) {
            heartBeatData(method1, componentName, () => { });
        }
        else {
            subscribeToData(method1, componentName, () => { });
        }
    };
    useEffect(() => {
        sendWsMessage(openFeedWsHeartBeat, positionData);
    }, [openFeedWsHeartBeat, positionData]);
    const openFeedWsMsg = useAppSelector((state) => {
        if (isEmpty(positionData)) {
        }
        else {
            let updatedMsg = state.openFeedWs.message;
            if (updatedMsg) {
                if (Array.isArray(updatedMsg)) {
                    updatedMsg = updatedMsg[0];
                }
                if ((updatedMsg === null || updatedMsg === void 0 ? void 0 : updatedMsg.LastQty) != undefined) {
                    const filter = positionData.filter((singleElement) => {
                        if (singleElement.ScripCode == (updatedMsg === null || updatedMsg === void 0 ? void 0 : updatedMsg.Token) &&
                            singleElement.Exch == updatedMsg.Exch &&
                            singleElement.ExchType == updatedMsg.ExchType) {
                            return singleElement;
                        }
                    });
                    if (filter.length > 0) {
                        return state.openFeedWs.message;
                    }
                }
            }
            return undefined;
        }
    });
    const setGetPL = (localPositionData, updateRedux) => {
        let BookedPL = 0;
        let UnbookedPL = 0;
        localPositionData.forEach((item) => {
            BookedPL = BookedPL + item.BookedPL;
            if (item.NetQty == 0) {
                item.MTOM = item.BookedPL;
            }
            else {
                item.Avg = calculateAveragePriceAsPerFilter(item, "all");
                const singleUnbookedPl = (item.LTP - item.Avg) * item.NetQty * item.Multiplier;
                UnbookedPL = UnbookedPL + singleUnbookedPl;
                item.MTOM = singleUnbookedPl + item.BookedPL;
            }
        });
        const totalPL = BookedPL + UnbookedPL;
        if (updateRedux) {
            dispatch(setPositionDetail(JSON.parse(JSON.stringify(localPositionData))));
        }
        // const totalPlType = Math.sign(totalPL);
        if (isNumber(BookedPL)) {
            dispatch(setBookedPLValue(BookedPL));
        }
        else {
            const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
            // logMessage(
            //   getIsNanPositionMessage(
            //     clientCode,
            //     "BookedPL",
            //     JSON.parse(JSON.stringify(localPositionData))
            //   )
            // );
        }
        if (isNumber(UnbookedPL)) {
            dispatch(setUnbookedPLValue(UnbookedPL));
        }
        else {
            const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
            // logMessage(
            //   getIsNanPositionMessage(
            //     clientCode,
            //     "UnbookedPL",
            //     JSON.parse(JSON.stringify(localPositionData))
            //   )
            // );
        }
        if (updateRedux) {
            if (isNumber(totalPL)) {
                dispatch(setTotalPLValue(totalPL));
            }
        }
        else {
            if (isNumber(totalPL)) {
                setTotalPL(totalPL);
            }
        }
        // dispatch(setPositionDetail(localPositionData));
    };
    useEffect(() => {
        if (openFeedWsMsg) {
            updateOptionChain(openFeedWsMsg);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openFeedWsMsg]);
    const updateOptionChain = useCallback((update) => {
        if (Array.isArray(update)) {
            update = update[0];
        }
        if ((update === null || update === void 0 ? void 0 : update.Details) === undefined && (update === null || update === void 0 ? void 0 : update.OpenInterest) === undefined) {
            let isValueUpdated = false;
            positionData.forEach((singleScrip) => {
                if (singleScrip.ScripCode == (update === null || update === void 0 ? void 0 : update.Token)) {
                    singleScrip.LTP = update.LastRate;
                    singleScrip.PClose = update.PClose;
                    isValueUpdated = true;
                }
            });
            if (isValueUpdated) {
                setGetPL(positionData, false);
                //setPositionData(positionData);
            }
        }
    }, [positionData]);
    const openFooterTabId = useAppSelector((state) => {
        return state.modals.openFooterTabId;
    });
    //-------------------------------Websocket End---------------------------------------------------------
    const fetchPosition = (callOrderBook) => __awaiter(void 0, void 0, void 0, function* () {
        const firebaseCheck = getDataFromSession(SESSION_KEYS.CHECK_FIREBASE_POLLING);
        if (interval.current && callOrderBook) {
            clearTimeout(interval.current);
            interval.current = undefined;
            // console.log(interval.current, "clear");
        }
        let syncTime = moment().format("YYYY-MM-DD HH:mm:ss");
        try {
            //position fetch from api without day filter
            // const positionDataResponse = await getNetPositionNetWiseData();
            // const positionDataResponse: any = { data: getDummyNetPositionData() };
            // if (positionDataResponse.data.body.Status == 0) {
            //   const sortedData = orderBy(
            //     positionDataResponse?.data.body.NetPositionDetail,
            //     [
            //       (singleItem: NetPositionDetail) => {
            //         return singleItem.NetQty === 0;
            //       },
            //       "displayIndex",
            //     ],
            //     "asc"
            //   );
            //   setGetPL(sortedData, true);
            //   setPositionData(sortedData);
            // }
        }
        catch (error) {
            syncTime = moment().add(-100, "minute").format("YYYY-MM-DD HH:mm:ss");
        }
        finally {
            if (positionRefreshTriggered) {
                dispatch(setPositionRefreshTriggered(false));
            }
            //if new order set to true
            dispatch(refreshNetPosition(false));
            if (callOrderBook && firebaseCheck) {
                // interval.current = setTimeout(
                //   () =>
                //     // getOrderUpdatesCallback(lastOrderUpdateTime.current, callOrderBook),
                //     refreshTime
                // );
            }
        }
    });
    // useEffect(() => {
    //   if (!getDataFromSession(SESSION_KEYS.CHECK_FIREBASE_POLLING)) {
    //     fetchPosition();
    //   }
    // }, []);
    //fetch position on basis of windows focus
    useEffect(() => {
        if (isWindowFocused) {
            if (getDataFromSession(SESSION_KEYS.CHECK_FIREBASE_POLLING)) {
                // console.log("POLLING START");
                // fetchPosition(true);
            }
            else {
                // fetchPosition();
            }
        }
        else if (interval.current) {
            clearTimeout(interval.current);
            interval.current = undefined;
        }
        return () => {
            if (interval.current) {
                clearTimeout(interval.current);
                interval.current = undefined;
            }
        };
    }, [isWindowFocused]);
    //Detect Change from WebSocket trigger to Update Positions
    useEffect(() => {
        if (positionUpdateSocketTrigger) {
            // fetchPosition();
        }
    }, [positionUpdateSocketTrigger]);
    //Detect Change from WebSocket trigger to Update Orders
    useEffect(() => {
        if (orderUpdateSocketTrigger) {
            getOrderBookCaching(false);
        }
    }, [orderUpdateSocketTrigger]);
    //Check if Polling is Enabled or Disabled
    useEffect(() => {
        if (getDataFromSession(SESSION_KEYS.CHECK_FIREBASE_POLLING) ||
            isPollingEnable ||
            pollingUpdateFireBase) {
            //console.log("Polling Started");
            // interval.current = setInterval(
            //   () => {
            // fetchPosition(true);
            // },
            // refreshTime
            // );
        }
        else if (!getDataFromSession(SESSION_KEYS.CHECK_FIREBASE_POLLING) &&
            !isPollingEnable) {
            // console.log("STOP");
            if (interval.current) {
                clearTimeout(interval.current);
                interval.current = undefined;
            }
        }
        return () => {
            if (interval.current) {
                clearTimeout(interval.current);
                interval.current = undefined;
            }
        };
    }, [isPollingEnable, pollingUpdateFireBase]);
    //on basis of refresh button change fetch data only
    useEffect(() => {
        if (positionRefreshTriggered) {
            // fetchPosition();
        }
    }, [positionRefreshTriggered]);
    //callNetPosition when new order is placed
    useEffect(() => {
        if (callNetPosition &&
            getDataFromSession(SESSION_KEYS.CHECK_FIREBASE_POLLING)) {
            // fetchPosition();
            getOrderBookCaching(false);
        }
        // setGetPL();
        return () => {
            //dispatch(setPositionDetail([]));
        };
    }, [callNetPosition]);
    //get status of order and trade
    const getOrderUpdatesCallback = useCallback((localSyncTime, loadOrderBookApi) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield getOrderUpdates(localSyncTime);
            if (response.data.body.Status == 0 &&
                (response.data.body.ChangeOnTrade == "Y" ||
                    response.data.body.ChangeOnOrderBook == "Y")) {
                if (response.data.body.ChangeOnOrderBook == "Y" &&
                    openFooterTabId !== "orders") {
                    getOrderBookCaching(false);
                }
                dispatch(setChangeOnOrder({
                    changeOnTrade: response.data.body.ChangeOnTrade,
                    changeOnOrderbook: response.data.body.ChangeOnOrderBook,
                    status: 0,
                }));
                dispatch(marginUpdate(true));
                lastOrderUpdateTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
                return;
            }
            // setTimeout(() => getOrderUpdatesCallback(localSyncTime), refreshTime);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            if (loadOrderBookApi) {
                // fetchPosition(loadOrderBookApi);
            }
        }
    }), []);
    return (_jsxs("div", Object.assign({ className: `${styles.tabView} positionTabBig`, id: "positions", onClick: () => {
            var _a;
            onTabChange("positions");
            ((_a = document.getElementById("positions")) === null || _a === void 0 ? void 0 : _a.classList.contains("activeTab"))
                ? false
                : dispatch(onModalOpenClose({
                    componentName: "PositionDashboard",
                    currState: "close",
                }));
            handlePositionClick();
        } }, { children: [_jsx("span", { className: "positionTab" }), _jsx("span", Object.assign({ className: "mediumWeight ms-2" }, { children: "Positions" })), _jsxs("span", Object.assign({ className: `${styles.upFrontFont}` }, { children: ["(P/L :", " ", _jsx("span", Object.assign({ className: `${totalPL > 0 ? styles.positiveColor : styles.negativeColor}` }, { children: convertNumberToShortText(totalPL) })), ")"] }))] })));
};
export default FooterPNL;
